var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg100TickGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1666 10.0007C19.1666 15.0633 15.0625 19.1673 9.99992 19.1673C4.93731 19.1673 0.833252 15.0633 0.833252 10.0007C0.833252 4.93804 4.93731 0.833984 9.99992 0.833984C15.0625 0.833984 19.1666 4.93804 19.1666 10.0007ZM14.7483 7.88898C15.0779 7.56769 15.0845 7.0401 14.7633 6.71057C14.442 6.38104 13.9144 6.37436 13.5848 6.69565L8.61103 11.5451L6.415 9.40398C6.08547 9.08269 5.55788 9.08937 5.23658 9.4189C4.91529 9.74843 4.92197 10.276 5.2515 10.5973L8.02928 13.3056C8.35293 13.6212 8.86913 13.6212 9.19278 13.3056L14.7483 7.88898Z",
    fill: "#129C49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100TickGreen);
export default __webpack_public_path__ + "static/media/100-tick-green.53f693af833b09c3d2d9efaaeaa2879c.svg";
export { ForwardRef as ReactComponent };